import { useState } from 'react';
import usePreferences from './usePreferences';


const useDataGridStyles = () => {
    const {settings} = usePreferences();
    const defaultFontSize = settings.tableFontSize();
    const defaultRowHeight = settings.tableRowHeight();
    const [fontSize, setFontSize] = useState(defaultFontSize);
    const [rowHeight, setRowHeight] = useState(defaultRowHeight);
    return {fontSize, setFontSize, rowHeight, setRowHeight}
}

export default useDataGridStyles;